<template>
  <!-- <div class="team-link col-sm-3" v-if="!filteredOut"> -->
  <li class="table-item">
    <ul>
      <li class="table-column title slate-bold">
        {{ quote.name }}
      </li>
      <li class="table-column source">
        <a :href="projectLink" rel="noreferrer" target="_blank">{{
          quote.project && quote.project.type
        }}</a>

        <span class="slate-light">{{
          (quote.project && quote.project.name) || "Untitled"
        }}</span>
      </li>
      <li class="table-column rep">{{ repName }}</li>
      <li class="table-column date">{{ dateFormatted }}</li>
      <li class="table-column quote">
        {{ quote.quote_id }}
      </li>
      <li class="table-column link" v-if="showLink">
        <router-link class="btn" :to="quoteLink"> View Details </router-link>
      </li>
    </ul>
  </li>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: "MyQuotesRow",
  props: ["quote", "typeOfProject", "loading", "statusClass", "showLink"],

  data() {
    return {
      showMenuAction: false,
    };
  },

  computed: {
    ...mapState(["auth", "dealer", "settings"]),

    archiveEnabled() {
      return this.statusLabel?.toLowerCase() !== "archived";
    },

    dateFormatted() {
      const currentDate = new Date(this.quote.created_at);
      const day = currentDate.getDate();
      const month = currentDate.getMonth() + 1;
      const year = currentDate.getFullYear();
      return `${month}/${day}/${year}`;
    },

    dateDescription() {
      return this.hasRep
        ? ` created by ${this.repName} on ${this.dateFormatted}`
        : ` created on ${this.dateFormatted}`;
    },

    hasRep() {
      return this.quote.user_id;
    },

    isPlaybook() {
      return this.typeOfProject === "playbook";
    },

    isSnapsheet() {
      return this.typeOfProject === "snapsheet";
    },

    isInstantPlaybook() {
      return this.isPlaybook && this.quote.pdf_url ? false : true;
    },

    projectLink() {
      if (this.isPlaybook) {
        return this.isInstantPlaybook
          ? this.settings.gameplanUrl +
              "/playbooks/" +
              this.dealer.rhino_code +
              "/" +
              this.quote.project?.id +
              "?passcode=" +
              this.dealer.passcode
          : this.quote.pdf_url;
      } else {
        return (
          this.settings.gameplanUrl +
          "/snapsheets/" +
          this.dealer.rhino_code +
          "/" +
          this.quote.project?.id +
          "?passcode=" +
          this.dealer.passcode
        );
      }
    },

    quoteLink() {
      return "/dashboard/quotes/" + this.quote.quote_id;
    },

    repName() {
      if (this.quote.user_id) {
        for (let index = 0; index < this.dealer.reps.length; index++) {
          const rep = this.dealer.reps[index];
          if (rep.id === this.quote.user_id) {
            return rep.name;
          }
        }
      }
      return "N/A";
    },

    statusLabel() {
      //NewPlaybooks
      if (this.quote.status) {
        switch (this.quote.status?.toLowerCase()) {
          case "active":
            return "Published";

          case "open":
            return "Published";

          case "published":
            return "Published";

          case "locker":
            return "Open Locker";

          case "quote":
            return "Open Locker";

          case "archived":
            return "Archived";

          case "draft":
            return "Draft (Autosaved)";

          default:
            return "Draft (Autosaved)";
        }
      }
      //Old Playbooks
      else {
        switch (this.quote.status_name) {
          case "Uploaded to S3":
            return "Complete";
          case "Playbook Approved":
            return "Complete";
          case "Archived":
            return "Archived";
          case "published":
            return "Published";
          case "draft":
            return "Draft";
          default:
            return "Processing";
        }
      }
    },

    statusIcon() {
      const imgPath =
        this.quote.status?.toLowerCase() === "draft"
          ? "status-empty.png"
          : "status-filled.png";
      return imgPath;
    },
  },

  methods: {
    async changeProjectStatus(status) {
      try {
        if (this.isInstantPlaybook || this.isSnapsheet) {
          const playbookUrl = `${this.settings.endpoint}api/v2/playbooks/${this.quote.id}`;
          const snapsheetUrl =
            this.settings.endpoint + `api/snapsheets/${this.quote.id}`;
          const url = this.isPlaybook ? playbookUrl : snapsheetUrl;
          const params = {
            status,
          };
          await axios.put(url, params, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.auth.apiToken,
            },
          });
          const message =
            status === "archived" ? "Project archived" : "Project updated";
          this.$store.dispatch("showToast", {
            txt: message,
          });
          this.$emit("changeProjectStatus", status);
        } else {
          status === "archived" && (await this.archiveOldPlaybook());
        }
      } catch (error) {
        console.log(error);
      }
    },

    async archiveOldPlaybook() {
      try {
        await axios({
          method: "POST",
          url: this.settings.playbookEndpoint + "archive-playbook",
          data: { playbook_id: this.quote.id },
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.auth.apiToken,
          },
        });
        this.quote.status_name = "Archived";
        this.$store.dispatch("showToast", {
          txt: `Playbook "${this.quote.title}" archived`,
        });
      } catch (error) {
        this.$store.dispatch("showToast", {
          txt: error,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
  position: relative;
  width: 10%;
  .actions-menu {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px;
    width: 150px;
    /* white */

    background: #ffffff;
    box-shadow: 0px -1.87px 18.2546px rgba(40, 42, 48, 0.16);
    border-radius: 8px;

    position: absolute;
    bottom: -5rem;
    right: 6rem;
    z-index: 10;

    li {
      border-radius: 6px;
      display: flex;
      align-items: center;
      padding: 0.5rem;
      width: 100%;

      &:hover {
        background: #f5f5f5;
        cursor: pointer;
      }
      img {
        width: 1.1rem;
        height: 1.1rem;
        margin-right: 0.5rem;
      }
      a,
      span,
      p {
        color: black;
      }
    }
  }
}

.table-item {
  .source {
    a {
      color: $dark;
      &:hover {
        color: $showroomColor;
        text-decoration: underline !important;
      }
    }
  }
}
</style>